import React from 'react';
import {
  Box,
  InputAdornment,
  TextField,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface DealerSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const DealerSearchInput: React.FC<DealerSearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search dealers...',
}) => (
  <Box
    sx={{
      p: 1,
      borderBottom: '1px solid',
      borderColor: 'divider',
      position: 'sticky',
      top: 0,
      bgcolor: 'background.paper',
      zIndex: 1,
    }}
    onKeyDown={event => event.stopPropagation()}
  >
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={event => onChange(event.target.value)}
      fullWidth
      autoFocus
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    />
  </Box>
);
